module.exports = __webpack_public_path__ + "img/ctc-tip-image.5855229.svg";